<template>
  <div class="confirmation">
    <div class="appointment-info">
      <div class="appointment">
        <h2>
          <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none">
            <path d="M40.375 40.375H10.625V17H40.375M40.375 6.375H38.25V2.125H34V6.375H17V2.125H12.75V6.375H10.625C9.49783 6.375 8.41683 6.82277 7.6198 7.6198C6.82277 8.41683 6.375 9.49783 6.375 10.625V40.375C6.375 41.5022 6.82277 42.5832 7.6198 43.3802C8.41683 44.1772 9.49783 44.625 10.625 44.625H40.375C41.5022 44.625 42.5832 44.1772 43.3802 43.3802C44.1772 42.5832 44.625 41.5022 44.625 40.375V10.625C44.625 9.49783 44.1772 8.41683 43.3802 7.6198C42.5832 6.82277 41.5022 6.375 40.375 6.375ZM35.1263 23.5025L32.8738 21.25L22.5037 31.62L17.9988 27.115L15.7463 29.3675L22.5037 36.125L35.1263 23.5025Z" fill="white" />
          </svg>
          <span>Booking Submitted</span>

        </h2>
        <div class="message">{{ response.message }}</div>
        <div class="appointment-date-info">
          <div>
            <div class="date" v-html="response.date" />
          </div>
          <div>
            <div class="date" v-html="response.time" />
          </div>
        </div>
        <div class="participant-info">
          <div class="primary" v-html="response.primary" />
        </div>
        <div class="ui">
          <Button text="Cancel Appointment" link="" v-if="!cancelled" @click="cancelAppointment" alternateTheme />
        </div>
      </div>
    </div>
    <img src="@/assets/images/confirmation.jpg" alt="" class="confirmed">
  </div>
</template>

<script>
  import Button from "@/components/Button";
  import axios from "axios";
  export default {
    name: "Confirmation",
    components: {
      Button,
    },
    props: {
      response: Object,
    },
    methods: {
      cancelAppointment() {
        this.cancelable = false;
        const params = new URLSearchParams();
        params.append("method", "cancel");
        params.append("id", this.cancelId);
        this.cancelled = true;
        axios
          .post(`${this.$store.state.API}/CancelAppointment.php`, params)
          .then(this.onCancelAppointment);
      },
      onCancelAppointment(response) {
        this.cancelled = false;
        if (response.data.status == "ok") {
          alert("Your appointment has been cancelled.");
          this.cancelled = true;
        } else {
          alert("There was a problem cancelling your appointment.");
        }
      },
    },
    computed: {
      cancelId() {
        return this.response.cancelId;
      },
    },
    data() {
      return {
        cancelled: false,
      /*
        response: {
          message: "Richard, you have successfully booked an appointment!",
          date: "June 24, 2022",
          time: "8:30 am",
          primary:
            "<p class='full-name'>Test F Tesxt L (test d)</p> <p class='email'>richard@channel1media.com</p> <p class='company'>Company</p> <p class='address'>65 Address</p>",

        },
        /* */
      };
    },
  };
</script>

<style lang="scss" scoped>
  .ui {
    display: flex;
    gap: 40px;
    margin-top: 40px;
  }

  .appointment-date-info {
    display: flex;
    gap: 30px;
    margin: 24px 0;

    p {
      text-transform: uppercase;
      font-weight: 400;
      font-size: 22px;
      margin: 0;
    }
  }

  .book {
    position: absolute;
    bottom: 30px;
    right: 50px;
    width: calc(100% - 100px);

    @media (min-width: 1125px) {
      width: auto;
      right: 30px;
    }
  }

  .confirmation {
    flex-direction: column;
    color: var(--white);
    border-radius: 0 0 6px 6px;
    border-radius: 6px;
    background: linear-gradient(180deg, rgba(0, 98, 65, 0.85) 50%, rgba(0, 77, 51, 0.85) 95%);
    overflow: hidden;

    @media (max-width:1124px) {
      .confirmed {
        display: none;
      }
    }

    @media (min-width:1125px) {
      flex-direction: row;

      .confirmed {
        flex-grow: 1;
        flex-shrink: 0;
        object-fit: cover;
      }
    }
  }

  .date {
    color: var(--white);
    font-family: "proxima-nova", sans-serif;
    font-size: 42px;
    font-weight: 800;
    text-transform: uppercase;
  }

  h2 {
    display: flex;
    align-items: center;
    gap: 15px;
    color: var(--white);
    font-family: "proxima-nova", sans-serif;
    font-weight: 800;
    text-transform: uppercase;
    font-size: 23px;
    @media (min-width:1130px) {
      font-size: 46px;      
    }
  }

  .primary {
    :deep() {
      p {
        color: var(--white);
        font-family: "proxima-nova", sans-serif;
        font-size: 15px;
        font-weight: 600;
        line-height: 1.1;
        margin: 0;

        &.full-name {
          font-weight: 800;
        }
      }
    }
  }

  .guest-info {
    :deep() {
      .guest {
        font-family: "proxima-nova", sans-serif;
        font-size: 15px;
        font-weight: 600;
        line-height: 1.1;
        margin: 0;

        &:first-child {
          margin-top: 8px;
        }
      }
    }
  }

  .appointment-info {
    display: flex;
    font-size: 1.25rem;
    flex-direction: column;

    @media (min-width: 1125px) {
      flex-direction: row;
      padding: 56px;
    }

    >div {
      padding: 15px;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .appointment {
      align-items: flex-start;
      position: relative;
      text-align: left;
      font-size: 30px;

      .message {
        color: var(--white);
        font-family: "proxima-nova", sans-serif;
        font-size: 18px;
        font-weight: 800;
        letter-spacing: 0.36px;
        text-transform: uppercase;
      }
    }
  }

  .location-info {
    margin: 24px 0;

    p {
      margin: 0;
      font-size: 14px;
      font-weight: 400;
    }
  }

  .participant-info {
    display: flex;
    flex-direction: column;
    gap: 35px;
  }
</style>